import { render } from "./StarsSvg.vue?vue&type=template&id=76263b58"
import script from "./StarsSvg.vue?vue&type=script&lang=js"
export * from "./StarsSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__